// extracted by mini-css-extract-plugin
export default {"button":"BEA8r__9","startIcon":"nzwsV0xy","endIcon":"_3Kb3Br1Z"};